






















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import warehouseCity from '@/store/entities/warehouse-city';
import warehouseInfo from '@/store/entities/warehouseInfo';
import courierModel from '@/store/entities/courier-express-delivery';
import appconst from '@/lib/appconst';
import courierCompanyList from '@/store/entities/back-couriercompany-list'

@Component({
    name:"courierExpressDeliveryCreate",
})
export default class CreateLogisticsModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    logistics: courierModel = new courierModel();
    warehouseCityId: number = 0;
    warehouseCityList: Array<warehouseCity> = [];
    warehouseInfoList: Array<warehouseInfo> = [];
    addLoding = false;
    CourierCompanyList: Array<courierCompanyList> = [];
    created() {
        this.getCity();
        this.get();
    }
    async get() {

        this.CourierCompanyList = await this.$store.dispatch({
            type: 'couriercompany/getCourierCompanyList',
            data: {}
        });
    }

    async playAudio() {
        var Audio2: any = document.getElementById("Audio2");
        Audio2.play();
    }
 
    save() {
        (this.$refs.logisticsCreateForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.addLoding = true;
                var id = await this.$store.dispatch({
                    type: 'courierExpressDelivery/add',
                    data: this.logistics
                }).finally(() => {
                       this.addLoding = false;
                });;
                this.logistics.reMark = "";
                this.logistics.shipment = "";
                this.playAudio();
                //this.$Modal.success({ title: "入库成功", content: "入库成功" });

                //if (id != null) {
                //    this.$Modal.confirm({
                //        title: "提示", content: "此快递需要拒收，是否拒收？", onOk: async () => {
                           
                //            await this.$store.dispatch({
                //                type: 'returnrejection/editConfirmRejection',
                //                data: { Id: id, HandleStatus: 0, HandleType: 2 }
                //            });
                //        }
                //    });
                //}
            }
        })
    }

    async changeWarehouseCity(val: number) {
        this.warehouseInfoList = await this.$store.dispatch({
            type: 'warehouseInfo/get',
            data: { CityId: val }
        });
        if (this.warehouseInfoList.length == 1) {
            this.logistics.warehouseInfoId = this.warehouseInfoList[0].id;
        }
    }
    async getCity() {
        this.warehouseCityList = await this.$store.dispatch({
            type: 'warehouseCity/get',
            data: {}
        });
        if (this.warehouseCityList.length > 0) {
            this.warehouseCityId = this.warehouseCityList[0].id;
            this.changeWarehouseCity(this.warehouseCityId);
        }
    }
    logisticsRule = {
        warehouseId: [
            { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
        ],
        shipment: [
            { required: true, max: 30, message: '快递单号不能为空，且长度必须小于30', trigger: 'blur' }
        ],
        reMark: [
            { max: 500, message: '长度不能大于500', trigger: 'blur' }
        ]
    };

}
